import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from "../../../middlewares/api/actions";
import {
  DATAFLOWS_DATAFLOW_CLONE_CHANGE,
  DATAFLOWS_DATAFLOW_CLONE_HIDE,
  DATAFLOWS_DATAFLOW_CLONE_SHOW,
  DATAFLOWS_DATAFLOW_CLONE_SUBMIT,
  DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_HIDE,
  DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_READ,
  DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_SHOW,
  DATAFLOWS_DATAFLOW_CREATE,
  DATAFLOWS_DATAFLOW_DELETE,
  DATAFLOWS_DATAFLOW_DOWNLOAD_CHANGE,
  DATAFLOWS_DATAFLOW_DOWNLOAD_HIDE,
  DATAFLOWS_DATAFLOW_DOWNLOAD_SHOW,
  DATAFLOWS_DATAFLOW_DOWNLOAD_SUBMIT,
  DATAFLOWS_DATAFLOW_EDIT,
  DATAFLOWS_DATAFLOW_EXPORT_CHANGE,
  DATAFLOWS_DATAFLOW_EXPORT_HIDE,
  DATAFLOWS_DATAFLOW_EXPORT_REPORT_HIDE,
  DATAFLOWS_DATAFLOW_EXPORT_SHOW,
  DATAFLOWS_DATAFLOW_EXPORT_SUBMIT,
  DATAFLOWS_DATAFLOW_EXPORT_LIST_SHOW,
  DATAFLOWS_DATAFLOW_OWNERSHIP_HIDE,
  DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_CHANGE,
  DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_READ,
  DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_SUBMIT,
  DATAFLOWS_DATAFLOW_OWNERSHIP_SHOW,
  DATAFLOWS_DATAFLOW_OWNERSHIP_USERS_READ,
  DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_HIDE,
  DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_READ,
  DATAFLOWS_DETAIL_AGENCIES_READ,
  DATAFLOWS_DETAIL_ANNOTATIONS_HIDE,
  DATAFLOWS_DETAIL_ANNOTATIONS_SHOW,
  DATAFLOWS_DETAIL_DATAFLOW_CHANGE,
  DATAFLOWS_DETAIL_DATAFLOW_CREATE_SUBMIT,
  DATAFLOWS_DETAIL_DATAFLOW_READ,
  DATAFLOWS_DETAIL_DATAFLOW_UPDATE_SUBMIT,
  DATAFLOWS_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ,
  DATAFLOWS_DETAIL_DSD_SET,
  DATAFLOWS_DETAIL_DSD_UNSET,
  DATAFLOWS_DETAIL_DSDS_HIDE,
  DATAFLOWS_DETAIL_DSDS_READ,
  DATAFLOWS_DETAIL_DSDS_SHOW,
  DATAFLOWS_DETAIL_HIDE,
  DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE,
  DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET,
  DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW,
  DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT,
  DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_HIDE,
  DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ,
  DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET,
  DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_SHOW,
  DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOW_SET,
  DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOW_UNSET,
  DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOWS_MODAL_CLOSE,
  DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOWS_MODAL_OPEN,
  DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOWS_READ,
  DATAFLOWS_DETAIL_LINKED_DATAFLOW_ENDPOINT_PING,
  DATAFLOWS_DETAIL_LINKED_DATAFLOW_ENDPOINT_SET,
  DATAFLOWS_LIST_DATAFLOWS_READ,
  DATAFLOWS_SELECTED_DATAFLOWS_DELETE,
  DATAFLOWS_DETAIL_LINKED_SOURCE_DSD_FOR_LAYOUT_ANNOTATIONS_READ,
  DATAFLOWS_DETAIL_LINKED_DATAFLOW_SOURCE_READ,
  DATAFLOWS_DETAIL_HIERARCHICAL_CODELISTS_READ, DATAFLOWS_DETAIL_ERASE_MAPPING_SET_INFO,
} from "./actions";

import {
  CODELIST_ORDER_ANNOTATION_KEY,
  getArtefactFromSdmxJsonStructure,
  getArtefactTripletFromUrn,
  getDsdFromSdmxJsonStructure,
  getItemSchemeFromSdmxJsonFactory,
  getSdmxStructuresFromSdmxJson,
  getStringFromArtefactTriplet,
  getUrnFromArtefactTriplet,
  SDMX_JSON_CODELIST_ITEMS_KEY,
  SDMX_JSON_DSD_URN_NAMESPACE
} from "../../../utils/sdmxJson";
import _ from 'lodash';
import { reuseInReducer, reuseReducer } from "../../../utils/reduxReuse";
import dsdDetailModalReducer from "../../../redux-components/redux-dsd-detail-modal/reducer";
import { getCurrentNodeConfig } from "../../../middlewares/current-node-config/middleware";
import contentConstraintDetailModalReducer
  from "../../../redux-components/redux-content-constraint-modal/reducer";
import {
  AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY,
  AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY,
  DATAFLOW_CATALOG_TYPE_ONLY_FILE,
  getCustomAnnotationsFromTabsMap,
  getCustomAnnotationsTabsMap,
  getGenericAnnotations,
  isStrCaseInsensitiveEquals,
} from "../../../utils/annotations";
import { getCurrentUserPermissions } from "../../../middlewares/current-user-permissions/middleware";
import {
  DATAFLOW_TYPE_NORMAL,
  DATAFLOW_TYPE_ONLY_FILE,
  DATAFLOW_TYPE_VIRTUAL
} from "../../../utils/dataflow";
import { setLinkedDataflowAnnotationText, setLinkedDataflowAnnotationTitle } from "./utils";


export const MM_DATAFLOWS_DSD_DETAIL_PREFIX = "MM_DATAFLOWS_DSD_DETAIL_PREFIX_";
export const MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX = "MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX_";
export const MM_DATAFLOWS_CC_DETAIL_PREFIX = "MM_DATAFLOWS_CC_DETAIL_PREFIX";

const DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD = {
  id: "VIRTUALDSD",
  agencyID: "MDM",
  version: "1.0"
};

const dataflowsReducer = (
  state = {
    isDetailVisible: false,
    dataflowTriplet: null,
    dataflows: null,
    isDataflowValid: true,
    isAgenciesValid: true,
    isDataflowGeneralTabDirty: false,
    dataflow: null,
    sourceDataflow: null,
    dsdForLayoutAnnotations: null,
    agencies: null,
    allAgencies: null,
    dsds: null,
    isDsdsListVisible: false,
    dsdDetail: null,
    selectedDsdTriplet: null,
    isDsdDetailVisible: false,
    downloadDataflowParams: null,
    downloadDataflowTriplets: null,
    downloadDataflowLang: null,
    cloneDestTriplet: null,
    dataflowAnnotations: null,
    dataflowLayoutAnnotations: null,
    dataflowAnnotationTriplet: null,
    dataflowExportSourceTriplet: null,
    dataflowExportDestination: null,
    dataflowExportReport: null,
    dataflowOwnershipDataflowTripletStr: null,
    dataflowOwnershipOwners: null,
    dataflowOwnershipUsers: null,
    parentsAndChildren: null,
    dataflowCCsDataflowTriplet: null,
    dataflowCCsContentConstraints: null,
    contentConstraintDetail: null,
    isLayoutAnnotationsFormVisible: false,
    dataflowOriginalAnnotations: null,
    itemsPageForLayoutAnnotations: null,
    isLinkedDFEndpointAvailable: null,
    isLinkedDFDataflowsModalOpen: false,
    linkedDFDataflows: null,    
    hierarchicalCodelists: null,
    mappingSetIsSuccessCallback: false,
    mappingSetCallbackInfo: null,
  },
  action
) => {
  switch (action.type) {
    case DATAFLOWS_DETAIL_ERASE_MAPPING_SET_INFO:
      return {
        ...state,
        mappingSetCallbackInfo: null
      }
    case DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SHOW:
      return {
        ...state,
        isLayoutAnnotationsFormVisible: true
      };
    case DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_HIDE:
      return {
        ...state,
        isLayoutAnnotationsFormVisible: false
      };
    case DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_SUBMIT:
      return {
        ...state,
        isLayoutAnnotationsFormVisible: false,
        dataflow: {
          ...state.dataflow,
          annotations: action.annotations
        }
      };
    case DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_FORM_RESET:
      return {
        ...state,
        dataflow: {
          ...state.dataflow,
          annotations: state.dataflowOriginalAnnotations
        }
      };
    case DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET:
      return {
        ...state,
        itemsPageForLayoutAnnotations: null
      };
    case DATAFLOWS_DATAFLOW_CREATE:
      return {
        ...state,
        dataflow: {
          id: null,
          agencyID: null,
          version: null,
          isFinal: false,
          uri: null,
          urn: null,
          validTo: null,
          validFrom: null,
          name: null,
          description: null,
          dsd: null,
          structure: null,
          annotations: null,
          dataflowType: DATAFLOW_TYPE_NORMAL,
          hasToReadDsdSource: false,
        },
        dataflowOriginalAnnotations: undefined,
        isDetailVisible: true,
        isAgenciesValid: false,
        isLinkedDFEndpointAvailable: false,
        linkedDFDataflows: null,
        sourceDataflow: null,
        dsdForLayoutAnnotations: null,
        mappingSetIsSuccessCallback: false,
        mappingSetCallbackInfo: null
      };
    case DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_SHOW:
      return {
        ...state,
        dataflowCCsDataflowTriplet: action.dataflowTriplet
      };
    case DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_HIDE:
      return {
        ...state,
        dataflowCCsDataflowTriplet: null,
        dataflowCCsContentConstraints: null
      };
    case DATAFLOWS_DATAFLOW_EXPORT_REPORT_HIDE:
      return {
        ...state,
        dataflowExportReport: null
      };
    case DATAFLOWS_DATAFLOW_OWNERSHIP_SHOW: {
      
      return {
        ...state,
        dataflowOwnershipDataflowTripletStr: action.dataflowTripletStr
      };
    }
    case DATAFLOWS_DATAFLOW_OWNERSHIP_HIDE:
      return {
        ...state,
        dataflowOwnershipDataflowTripletStr: null,
        dataflowOwnershipOwners: null,
        dataflowOwnershipUsers: null
      };
    case DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_CHANGE:
      return {
        ...state,
        dataflowOwnershipOwners: action.owners
      };
    case DATAFLOWS_DATAFLOW_EDIT:
      return {
        ...state,
        isDetailVisible: true,
        mappingSetCallbackInfo: null,
        dataflowTriplet: action.dataflowTriplet,
        isDataflowValid: false,
        isAgenciesValid: false,
        isDataflowGeneralTabDirty: false,
        mappingSetIsSuccessCallback: false
      };
    case DATAFLOWS_DETAIL_HIDE:
      return {
        ...state,
        isDetailVisible: false,
        mappingSetCallbackInfo: null,
        isLinkedDFDataflowsModalOpen: false,
        dataflowTriplet: null,
        dataflow: null,
        sourceDataflow: null,
        dsdForLayoutAnnotations: null,
        dsds: null,
        isDsdsListVisible: false,
        dsdDetail: null,
        selectedDsdTriplet: null,
        isDsdDetailVisible: false,
        agencies: null,
        allAgencies: null,
        hierarchicalCodelists: null,
        mappingSetIsSuccessCallback: false
      };
    case DATAFLOWS_DETAIL_DATAFLOW_CHANGE: {
      const dataflow = _.cloneDeep(state.dataflow);
      const customizer = (_, src, key) => {
        if (key === "annotations")
          return src;
        else {
          return undefined
        }
      };
      const newDataflow = _.mergeWith(dataflow, action.fields, customizer);

      const dataflowTypeIsChanged = newDataflow.dataflowType !== state.dataflow.dataflowType;

      let dsdForLayoutAnnotations = state.dsdForLayoutAnnotations;
      let sourceDataflow = state.sourceDataflow;
      let hasToReadDsdSource = newDataflow.hasToReadDsdSource;

      let newAutoAnnotations = newDataflow.autoAnnotations;
      const currentNodeConfigAnnotations = getCurrentNodeConfig(action).annotations;

      if (dataflowTypeIsChanged) {
        dsdForLayoutAnnotations = null;
        sourceDataflow = null;
        hasToReadDsdSource = newDataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL;

        if (newDataflow.dataflowType === DATAFLOW_TYPE_ONLY_FILE) {
          // add "dataflow catalog type" annotation
          const dataflowCatalogTypeAnnotationType = currentNodeConfigAnnotations[AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY].type;
          newAutoAnnotations = [
            ...(newAutoAnnotations || []).filter((ann) => ann && !isStrCaseInsensitiveEquals(ann.type, dataflowCatalogTypeAnnotationType)),
            {
              type: dataflowCatalogTypeAnnotationType,
              id: dataflowCatalogTypeAnnotationType,
              title: DATAFLOW_CATALOG_TYPE_ONLY_FILE
            }
          ];
        }
      }

      if (newDataflow.dataflowType === DATAFLOW_TYPE_NORMAL) {
        hasToReadDsdSource = dsdForLayoutAnnotations ? false : true;
      }

      if (newDataflow.dataflowType !== DATAFLOW_TYPE_VIRTUAL) {
        // if dataflow type is not "linked (virtual)", remove related annotation
        newAutoAnnotations = (newAutoAnnotations || []).filter((ann) =>
        (ann && (ann.type || "").toLowerCase() !==
          (currentNodeConfigAnnotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "").toLowerCase())
        );
      }

      if (newDataflow.dataflowType !== DATAFLOW_TYPE_ONLY_FILE) {
        // if dataflow type is not "only file", remove related annotation
        newAutoAnnotations = (newAutoAnnotations || []).filter((ann) =>
        (ann && (ann.type || "").toLowerCase() !==
          (currentNodeConfigAnnotations[AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY].type || "").toLowerCase())
        );
      }

      // reflect dataflow type in isExternalReference
      newDataflow.isExternalReference = newDataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL;

      const newDataflowIsNotReal = newDataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL || newDataflow.dataflowType === DATAFLOW_TYPE_ONLY_FILE;
      const dataflowIsNotReal = state.dataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL || state.dataflow.dataflowType === DATAFLOW_TYPE_ONLY_FILE;

      return {
        ...state,
        dataflow: {
          ...newDataflow,
          isFinal: !state.dataflow.isExternalReference && newDataflow.isExternalReference ? true : newDataflow.isFinal,
          dsd: newDataflowIsNotReal
            ? getStringFromArtefactTriplet(DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD)
            : dataflowIsNotReal
              ? null
              : state.dataflow.dsd,
          structure: newDataflowIsNotReal
            ? getUrnFromArtefactTriplet(DATAFLOWS_DETAIL_VIRTUAL_DATAFLOW_DSD, SDMX_JSON_DSD_URN_NAMESPACE)
            : dataflowIsNotReal
              ? null
              : state.dataflow.structure,
          autoAnnotations: newAutoAnnotations,
          hasToReadDsdSource: hasToReadDsdSource,
        },
        isDataflowGeneralTabDirty: true,
        dataflowOriginalAnnotations: newDataflow.annotations,
        sourceDataflow: sourceDataflow,
        dsdForLayoutAnnotations: dsdForLayoutAnnotations,
      };
    }
    case DATAFLOWS_DETAIL_DSDS_SHOW:
      return {
        ...state,
        isDsdsListVisible: true
      };
    case DATAFLOWS_DETAIL_DSDS_HIDE:
      return {
        ...state,
        isDsdsListVisible: false,
        dsds: null
      };
    case DATAFLOWS_DETAIL_DSD_SET:
      return {
        ...state,
        isDsdsListVisible: false,
        dsds: null,
        dataflow: {
          ...state.dataflow,
          dsd: getStringFromArtefactTriplet(action.dsdTriplet),
          structure: getUrnFromArtefactTriplet(action.dsdTriplet, SDMX_JSON_DSD_URN_NAMESPACE),
          hasToReadDsdSource: true
        },
        selectedDsdTriplet: action.dsdTriplet,
        dsdDetail: null,
        dsdForLayoutAnnotations: null,
      };
    case DATAFLOWS_DETAIL_DSD_UNSET:
      return {
        ...state,
        dataflow: {
          ...state.dataflow,
          dsd: null,
          structure: null,
          hasToReadDsdSource: false
        },
        dsdDetail: null,
        dsdForLayoutAnnotations: null
      };
    case DATAFLOWS_DETAIL_ANNOTATIONS_SHOW:
      return {
        ...state,
        dataflowAnnotations: action.annotations,
        dataflowAnnotationTriplet: action.triplet
      };
    case DATAFLOWS_DETAIL_ANNOTATIONS_HIDE:
      return {
        ...state,
        dataflowAnnotations: null,
        dataflowAnnotationTriplet: null
      };
    case DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_SHOW:
      return {
        ...state,
        dataflowLayoutAnnotations: action.annotations,
        dataflowAnnotationTriplet: action.triplet
      };
    case DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_HIDE:
      return {
        ...state,
        dataflowLayoutAnnotations: null,
        dataflowAnnotationTriplet: null
      };
    case DATAFLOWS_DATAFLOW_DOWNLOAD_SHOW:
      return {
        ...state,
        downloadDataflowTriplets: action.artefactTriplets,
        downloadDataflowLang: action.lang,
        downloadDataflowParams: {
          format: null,
          references: false,
          compression: false,
          csvSeparator: ";",
          csvDelimiter: null,
          csvLanguage: null
        },
      };
      case DATAFLOWS_DATAFLOW_EXPORT_LIST_SHOW:
        return {
          ...state,
          downloadDataflowTriplets: action.artefactTriplets,
          downloadDataflowLang: action.lang,
          downloadDataflowParams: {
            format: "csv",
            hideFormat: true,
            hideLanguage: true,
            references: false,
            compression: false,
            csvSeparator: ";",
            csvDelimiter: null,
            csvLanguage: null
          },
        };
    case DATAFLOWS_DATAFLOW_DOWNLOAD_HIDE:
      return {
        ...state,
        downloadDataflowTriplets: null,
        downloadDataflowLang: null,
        downloadDataflowParams: null
      };
    case DATAFLOWS_DATAFLOW_DOWNLOAD_CHANGE:
      const downloadDataflowParams = _.cloneDeep(state.downloadDataflowParams);
      return {
        ...state,
        downloadDataflowParams: _.merge(downloadDataflowParams, action.fields)
      };
    case DATAFLOWS_DATAFLOW_CLONE_SHOW:
      const srcVersionArr = action.srcTriplet.version.split(".");
      const destVersionArr = srcVersionArr.map((num, index) =>
        index === srcVersionArr.length - 1
          ? Number(num) + 1
          : num
      );

      return {
        ...state,
        cloneDestTriplet: {
          ...action.srcTriplet,
          version: destVersionArr.join(".")
        },
        dataflowTriplet: state.dataflowTriplet ? state.dataflowTriplet : action.srcTriplet,
        isDataflowValid: !!state.dataflow,
        isAgenciesValid: !!state.allAgencies
      };
    case DATAFLOWS_DATAFLOW_CLONE_HIDE:
      return {
        ...state,
        cloneDestTriplet: null,
        dataflow: state.isDetailVisible ? state.dataflow : null,
        selectedDsdTriplet: state.selectedDsdTriplet ? state.dataflow : null,
        agencies: state.isDetailVisible ? state.agencies : null,
        allAgencies: state.isDetailVisible ? state.allAgencies : null
      };
    case DATAFLOWS_DATAFLOW_CLONE_CHANGE:

      const cloneDestTriplet = _.cloneDeep(state.cloneDestTriplet);

      return {
        ...state,
        cloneDestTriplet: _.merge(cloneDestTriplet, action.fields)
      };
    case DATAFLOWS_DATAFLOW_EXPORT_SHOW:
      return {
        ...state,
        dataflowExportSourceTriplet: action.sourceTriplet,
        dataflowExportDestination: {
          endpoint: null,
          username: null,
          password: null,
          id: action.sourceTriplet.id,
          agencyID: action.sourceTriplet.agencyID,
          version: action.sourceTriplet.version
        },
        isAgenciesValid: !!state.allAgencies
      };
    case DATAFLOWS_DATAFLOW_EXPORT_HIDE:
      return {
        ...state,
        dataflowExportSourceTriplet: null,
        dataflowExportDestination: null,
        agencies: state.isDetailVisible ? state.agencies : null,
        allAgencies: state.isDetailVisible ? state.allAgencies : null
      };
    case DATAFLOWS_DATAFLOW_EXPORT_CHANGE:

      const dataflowExportDestination = _.cloneDeep(state.dataflowExportDestination);
      _.merge(dataflowExportDestination, action.fields);

      return {
        ...state,
        dataflowExportDestination
      };
    case DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_HIDE:
      return {
        ...state,
        parentsAndChildren: null
      };
    case DATAFLOWS_DETAIL_LINKED_DATAFLOW_ENDPOINT_SET: {

      const linkedDataflowNodeAnnotationType = 
        (getCurrentNodeConfig(action).annotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "");      
      const autoAnnotations = setLinkedDataflowAnnotationTitle(linkedDataflowNodeAnnotationType, state.dataflow, action.endpointId)

      return {
        ...state,
        dataflow: {
          ...state.dataflow,
          autoAnnotations: autoAnnotations,
          hasToReadDsdSource: false,
        },
        sourceDataflow: null,
        dsdForLayoutAnnotations: null,
      };
    }
    case DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOW_SET: {
      const id = state.dataflow.id ? state.dataflow.id : action.dataflowTriplet.id;
      const agencyID = state.dataflow.agencyID ? state.dataflow.agencyID : action.dataflowTriplet.agencyID;
      const version = state.dataflow.version ? state.dataflow.version : action.dataflowTriplet.version;

      const linkedDataflowNodeAnnotationType = 
        (getCurrentNodeConfig(action).annotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "");      
      const autoAnnotations = setLinkedDataflowAnnotationText(linkedDataflowNodeAnnotationType, state.dataflow, action.dataflowTriplet);

      return {
        ...state,
        dataflow: {
          ...state.dataflow,
          id: id,
          agencyID: agencyID,
          version: version,
          autoAnnotations: autoAnnotations,
          hasToReadDsdSource: true,
        },
        isLinkedDFDataflowsModalOpen: false,
        dsdForLayoutAnnotations: null,
        sourceDataflow: null,        
      };
    }
    case DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOW_UNSET: {
      const linkedDataflowNodeAnnotationType =
        (getCurrentNodeConfig(action).annotations[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY].type || "");
      const autoAnnotations = setLinkedDataflowAnnotationText(linkedDataflowNodeAnnotationType, state.dataflow, null);

      return {
        ...state,
        dataflow: {
          ...state.dataflow,
          autoAnnotations: autoAnnotations,
          hasToReadDsdSource: false,
        },
        sourceDataflow: null,
        dsdForLayoutAnnotations: null,
      };
    }
    case DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOWS_MODAL_OPEN:
      return {
        ...state,
        isLinkedDFDataflowsModalOpen: true
      };
    case DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOWS_MODAL_CLOSE:
      return {
        ...state,
        isLinkedDFDataflowsModalOpen: false,
        linkedDFDataflows: null
      };
    case REQUEST_START:
      switch (action.label) {
        case DATAFLOWS_DETAIL_DATAFLOW_UPDATE_SUBMIT:
          return {
            ...state,
            isDataflowGeneralTabDirty: false,
            agencies: null,
            allAgencies: null
          };
        case DATAFLOWS_DETAIL_DSDS_READ:
          return {
            ...state,
            dsds: null
          };
        case DATAFLOWS_DETAIL_LINKED_DATAFLOW_ENDPOINT_PING:
          return {
            ...state,
            isLinkedDFEndpointAvailable: false
          };
        case DATAFLOWS_DETAIL_HIERARCHICAL_CODELISTS_READ:
          return {
            ...state,
            hierarchicalCodelists: null
          };
        default:
          return state;
      }
    case REQUEST_SUCCESS:
      switch (action.label) {
        case DATAFLOWS_DETAIL_LINKED_DATAFLOW_ENDPOINT_PING:
          return {
            ...state,
            isLinkedDFEndpointAvailable: action.response
          };
        case DATAFLOWS_DETAIL_LINKED_DATAFLOW_DATAFLOWS_READ:
          return {
            ...state,
            linkedDFDataflows:
              (getSdmxStructuresFromSdmxJson(action.response) || [])
                .map(artefact => getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
          };
        case DATAFLOWS_DETAIL_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ:
          return {
            ...state,
            itemsPageForLayoutAnnotations: getItemSchemeFromSdmxJsonFactory(
              SDMX_JSON_CODELIST_ITEMS_KEY,
              getCurrentNodeConfig(action).annotations,
              CODELIST_ORDER_ANNOTATION_KEY
            )(getSdmxStructuresFromSdmxJson(action.response)[0]).codes || []
          };
        case DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_READ:
          return {
            ...state,
            dataflowOwnershipOwners: action.response.owners.map(({username}) => username)
          };
        case DATAFLOWS_DATAFLOW_OWNERSHIP_USERS_READ:
          return {
            ...state,
            dataflowOwnershipUsers: action.response
          };
        case DATAFLOWS_DATAFLOW_OWNERSHIP_OWNERS_SUBMIT:
          return {
            ...state,
            dataflowOwnershipDataflowTripletStr: null,
            dataflowOwnershipOwners: null,
            dataflowOwnershipUsers: null
          };
        case DATAFLOWS_LIST_DATAFLOWS_READ:
          return {
            ...state,
            dataflows:
              (getSdmxStructuresFromSdmxJson(action.response) || [])
                .map(artefact => getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
          };
        case DATAFLOWS_DETAIL_DATAFLOW_READ:

          const userPermissions = getCurrentUserPermissions(action);
          const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
            ? () => false
            : undefined;

          const dataflow = getArtefactFromSdmxJsonStructure(getSdmxStructuresFromSdmxJson(action.response)[0], getCurrentNodeConfig(action).annotations, customNoneIsAutoAnnotation);

          const annotationTabsConfig = getCurrentNodeConfig(action).annotationTabs.tabs;
          const annotationsConfig = getCurrentNodeConfig(action).annotations;

          const linkedDataflowAnnotation = annotationsConfig[AUTO_ANNOTATION_LINKED_DATAFLOW_NODE_KEY];
          const catalogTypeAnnotation = annotationsConfig[AUTO_ANNOTATION_DATAFLOW_CATALOG_TYPE_NODE_KEY];

          const isExternalReference = !![
            ...(dataflow.annotations || []),
            ...(dataflow.autoAnnotations || [])
          ].find((ann) => ann && isStrCaseInsensitiveEquals(ann.type, linkedDataflowAnnotation.type));
          const isOnlyFile = !![
            ...(dataflow.annotations || []),
            ...(dataflow.autoAnnotations || [])
          ].find((ann) => ann && isStrCaseInsensitiveEquals(ann.type, catalogTypeAnnotation.type));

          
          return {
            ...state,
            dataflow: {
              ...dataflow,
              isExternalReference,
              dataflowType:
                isExternalReference
                  ? DATAFLOW_TYPE_VIRTUAL
                  : (
                    isOnlyFile
                      ? DATAFLOW_TYPE_ONLY_FILE
                      : DATAFLOW_TYPE_NORMAL
                  ),
              dsd: dataflow.structure ? getStringFromArtefactTriplet(getArtefactTripletFromUrn(dataflow.structure)) : null,
              hasToReadDsdSource: (isOnlyFile) ? false : true
            },
            selectedDsdTriplet: dataflow.structure ? getArtefactTripletFromUrn(dataflow.structure) : null,
            isDataflowValid: true,
            dataflowOriginalAnnotations: [
              ...getGenericAnnotations(dataflow.annotations, annotationTabsConfig, annotationsConfig),
              ...getCustomAnnotationsFromTabsMap(getCustomAnnotationsTabsMap(dataflow.annotations, annotationTabsConfig)),
              (dataflow.autoAnnotations || []).find((ann) =>
                ann && isStrCaseInsensitiveEquals(ann.type, linkedDataflowAnnotation.type)                
              )
            ],
            isLinkedDFEndpointAvailable: null,
            sourceDataflow: null,
            dsdForLayoutAnnotations: null,
          };
        case DATAFLOWS_DETAIL_AGENCIES_READ:
          return {
            ...state,
            agencies: _.pickBy(action.response, (_, agencyID) => !action.allowedAgencies || action.allowedAgencies.includes(agencyID)),
            allAgencies: action.response,
            isAgenciesValid: true
          };
        case DATAFLOWS_DETAIL_DATAFLOW_CREATE_SUBMIT:
        case DATAFLOWS_DATAFLOW_DELETE:
          return {
            ...state,
            dataflow: null,
            dataflows: null,
            isDetailVisible: false,
            agencies: null,
            allAgencies: null,
            sourceDataflow: null,
            dsdForLayoutAnnotations: null,
            mappingSetCallbackInfo: state.dataflow,
            mappingSetIsSuccessCallback: true,
          };
        case DATAFLOWS_DETAIL_DATAFLOW_UPDATE_SUBMIT:
          return {
            ...state,
            dataflow: null,
            dataflows: null,
            isDataflowValid: false,
            isDetailVisible: false,
            item: null,
            sourceDataflow: null,
            dsdForLayoutAnnotations: null,
            mappingSetCallbackInfo: null,
            mappingSetIsSuccessCallback: true,
          };
        case DATAFLOWS_DETAIL_DSDS_READ:
          return {
            ...state,
            dsds: (getSdmxStructuresFromSdmxJson(action.response) || [])
              .map(artefact => getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
          };
        case DATAFLOWS_SELECTED_DATAFLOWS_DELETE:
          return {
            ...state,
            dataflow: null,
            dataflows: null,
            sourceDataflow: null,
            dsdForLayoutAnnotations: null,
            mappingSetIsSuccessCallback: true
          };
        case DATAFLOWS_DATAFLOW_DOWNLOAD_SUBMIT:
          return {
            ...state,
            downloadDataflowTriplets: null,
            downloadDataflowLang: null,
            downloadDataflowParams: null
          };
        case DATAFLOWS_DATAFLOW_CLONE_SUBMIT:
          return {
            ...state,
            dataflows: null,
            cloneDestTriplet: null,
            dataflow: state.isDetailVisible ? state.dataflow : null,
            selectedDsdTriplet: state.selectedDsdTriplet ? state.selectedDsdTriplet : null,
            agencies: state.isDetailVisible ? state.agencies : null,
            allAgencies: state.isDetailVisible ? state.allAgencies : null
          };
        case DATAFLOWS_DATAFLOW_EXPORT_SUBMIT:
          return {
            ...state,
            dataflowExportSourceTriplet: null,
            dataflowExportDestination: null,
            dataflowExportReport: action.response.itemsMessage,
            agencies: state.isDetailVisible ? state.agencies : null,
            allAgencies: state.isDetailVisible ? state.allAgencies : null
          };
        case DATAFLOWS_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ:
        case DATAFLOWS_DETAIL_LINKED_SOURCE_DSD_FOR_LAYOUT_ANNOTATIONS_READ: {
          const sdmxStructure = getSdmxStructuresFromSdmxJson(action.response);
          const dsd = (sdmxStructure || []).length > 0
            ? getDsdFromSdmxJsonStructure(sdmxStructure[0], getCurrentNodeConfig(action).annotations)
            : null;
          return {
            ...state,
            dataflow: {
              ...state.dataflow,
              hasToReadDsdSource: dsd !== null
            },
            dsdForLayoutAnnotations: dsd,
          }
        }
        case DATAFLOWS_DATAFLOW_PARENTS_AND_CHILDREN_READ:
          return {
            ...state,
            parentsAndChildren: action.response
          };
        case DATAFLOWS_DATAFLOW_CONTENT_CONSTRAINTS_READ:
          return {
            ...state,
            dataflowCCsContentConstraints:
              action.response
                .map(art => getArtefactFromSdmxJsonStructure(art, getCurrentNodeConfig(action).annotations))
                .map(cc => ({
                  ...cc,
                  agencyID: cc.agency
                }))
          };
        case DATAFLOWS_DETAIL_LINKED_DATAFLOW_SOURCE_READ: {
          const userPermissions = getCurrentUserPermissions(action);
          const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
            ? () => false
            : undefined;

          const sourceDataflow = getArtefactFromSdmxJsonStructure(getSdmxStructuresFromSdmxJson(action.response)[0], getCurrentNodeConfig(action).annotations, customNoneIsAutoAnnotation);

          return {
            ...state,
            dataflow: {
              ...state.dataflow,
              hasToReadDsdSource: true
            },
            sourceDataflow: sourceDataflow,
            dsdForLayoutAnnotations: null
          }
        }
        case DATAFLOWS_DETAIL_HIERARCHICAL_CODELISTS_READ:
          return {
            ...state,
            hierarchicalCodelists: getSdmxStructuresFromSdmxJson(action.response).map(artefact =>
              getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
          };         
        default:
          return state;
      }      
    case REQUEST_ERROR:
      switch (action.label) {
        case DATAFLOWS_DETAIL_DATAFLOW_READ:
          return {
            ...state,
            isDetailVisible: false,
            isDataflowValid: true
          };          
        case DATAFLOWS_SELECTED_DATAFLOWS_DELETE:
          return {
            ...state,
            dataflows: null,
            mappingSetIsSuccessCallback: false
          };
        case DATAFLOWS_DETAIL_LINKED_DATAFLOW_SOURCE_READ:
          return {
            ...state,
            dataflow : {
              ...state.dataflow,
              hasToReadDsdSource: false
            },
            sourceDataflow: null,
            dsdForLayoutAnnotations: null
          };
        case DATAFLOWS_DETAIL_DSD_FOR_LAYOUT_ANNOTATIONS_READ:
        case DATAFLOWS_DETAIL_LINKED_SOURCE_DSD_FOR_LAYOUT_ANNOTATIONS_READ:
          return {
            ...state,
            dataflow: {
              ...state.dataflow,
              hasToReadDsdSource: false
            },
            dsdForLayoutAnnotations: null,
            sourceDataflow: null,
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

export default reuseInReducer(dataflowsReducer, {
  dsdDetail: reuseReducer(dsdDetailModalReducer, MM_DATAFLOWS_DSD_DETAIL_PREFIX),
  selectedDsdDetail: reuseReducer(dsdDetailModalReducer, MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX),
  contentConstraintDetail: reuseReducer(contentConstraintDetailModalReducer, MM_DATAFLOWS_CC_DETAIL_PREFIX)
});